module.exports = __webpack_public_path__ + "img/key-visual.03dc45fb.jpg";